// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-radio:checked ~ .input-radio__circle[data-v-b6e87330] {\n  display: none;\n}\n.input-radio:not(:checked) ~ .input-radio__checked[data-v-b6e87330] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
